type OnLayoutChange = () => void;

const layoutChangeCallbacks: Array<OnLayoutChange> = [];

function onLayoutChange(callback: OnLayoutChange) {
    layoutChangeCallbacks.push(callback);
    setTimeout(callback);
}

function layoutChanged() {
    layoutChangeCallbacks.forEach(callback => callback());
}

window.addEventListener('resize', layoutChanged);
window.addEventListener('orientationchange', layoutChanged);
const allStylesheets = document.querySelectorAll('link[rel=stylesheet]');
for(let i = 0; i < allStylesheets.length; i++) {
    const ele = allStylesheets[i];
    ele.addEventListener('load', layoutChanged);
}
// import type {FontFaceSet} from "css-font-loading-module"; //TODO?
// if('fonts' in (document as object)) {
//     (document.fonts as FontFaceSet).ready.then(layoutChanged);
// }
window.addEventListener('load', layoutChanged);
window.addEventListener('DOMContentLoaded', layoutChanged);

// scrollbar-width für scss verfügbar machen:
(() => {
    var e = document.createElement("div");
    e.style.visibility = "hidden", e.style.width = "100px", document.body.append(e);
    var t = e.offsetWidth; e.style.overflow = "scroll";
    var o = document.createElement("div");
    o.style.width = "100%", e.append(o);
    var d = o.offsetWidth; e.remove();
    document.body.style.setProperty("--scrollbar-width", (t - d) + "px");
})();

export {onLayoutChange};
